module.exports = __webpack_public_path__ + "static/media/LOSE.a4e91ab4.png";